import React, { useState } from 'react';
import Modal from '../Modal';
import { getLabel } from '../../data/labels';
import ScannerModalContent from './ScannerModalContent';

export default function ScannerButton() {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <>
            {showPopup &&
                <Modal title={getLabel('check_ticket.check_ticket')} onClick={() => setShowPopup(false)}>
                    <ScannerModalContent />
                </Modal>
            }
            <div onClick={() => setShowPopup(true)}>
                <i className="bi-upc-scan text-lg text-cs1"></i>
            </div>
        </>
    );
}
